import { ButtonProps } from '../Button/Button.types';
import { AngleInputProps } from '../AngleInput/AngleInput.types';
import { IconButtonProps } from '../IconButton';
import { AccordionProps } from '../Accordion';
import { TableListItemProps } from '../TableListItem';
import { TextButtonProps } from '../TextButton/TextButton.types';
import { InputProps } from '../Input/Input.types';
import { DropdownProps } from '../Dropdown';
import { AutoCompleteProps } from '../AutoComplete';
import { MultiSelectProps } from '../MultiSelect';
import { MultiSelectCheckboxProps } from '../MultiSelectCheckbox';
import { NumberInputProps } from '../NumberInput';
import { HeaderProps as SidePanelHeaderProps } from '../SidePanel/components/Header';
import { SidePanelProps } from '../SidePanel';
import { ThumbnailProps } from '../Thumbnail/Thumbnail.types';
import { TableActionCellProps } from '../TableActionCell/TableActionCell.types';
import { PopoverMenuProps } from '../PopoverMenu';
import { DockProps } from '../Dock/Dock.types';

export interface ProviderDefaultPropSupportedComponents {
  Button: ButtonProps;
  IconButton: IconButtonProps;
  Accordion: AccordionProps;
  TableListItem: TableListItemProps;
  TableActionCell: TableActionCellProps;
  TextButton: TextButtonProps;
  Input: InputProps;
  NumberInput: NumberInputProps;
  AngleInput: AngleInputProps;
  Dropdown: DropdownProps;
  AutoComplete: AutoCompleteProps;
  MultiSelect: MultiSelectProps;
  MultiSelectCheckbox: MultiSelectCheckboxProps;
  ['SidePanel.Header']: SidePanelHeaderProps;
  SidePanel: SidePanelProps;
  Thumbnail: ThumbnailProps;
  PopoverMenu: PopoverMenuProps;
  Dock: DockProps;
}

export type ProviderDefaultPropSupportedComponentName =
  keyof ProviderDefaultPropSupportedComponents;

export type WixDesignSystemDefaultProps = {
  [K in ProviderDefaultPropSupportedComponentName]?: Partial<
    ProviderDefaultPropSupportedComponents[K]
  >;
};
